import { gql } from '@apollo/client';
import { ContactFragment } from '../fragments/ContactFragment';
/**
 * @const CreateContactMutation
 * @since 1.0.0
 */
export const CreateContactMutation = gql `
  mutation CreateContactMutation($input: CreateContactInput!) {
    createContact(input: $input) {
      ...ContactFragment
    }
  }

  ${ContactFragment}
`;
